// extracted by mini-css-extract-plugin
module.exports = {"expander":"_1hhcI","expanderTextWrapper":"_30kro","expanderInner":"_1X8u4","expanderIcon":"_3JAHX","rotateIcon":"_3fB5c"};